module.exports = __webpack_public_path__ + "static/media/number-matka.2af5add2.png";